import { create } from "zustand";
import { message } from "antd";

import AdminApiCaller from "../config/api/adminapicaller";

const initialState = {
  support: [],
  supportCount: 0,
  isSupportLoading: false,
  error: null,
};

export const useSupportStore = create((set) => {
  const setSupport = (partial) => set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    getSupport: async (payload, cb) => {
      try {
        setSupport({ isSupportLoading: true, error: null });
        const res = await AdminApiCaller.Post("/getsupport", payload);
        if (res?.status === 200) {
          setSupport({
            support: res.data.support,
            supportCount: res.data.count,
            isSupportLoading: false,
          });
        } else {
          message.error(res?.data?.message);
          setSupport({ isSupportLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setSupport({ isSupportLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
